import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import './FormWrapper.css';
import CustomButton from '../Button/customButton/CustomButton';

const FormWrapper = ({ title, subheading, children, loading, onSubmit, error, buttonName='Submit', submitDisabled = false }) => {
  return (
    <Box className="box-container">
      <Box className="box-card">
        <Box className="logo-container">
            <img
            src="/image.png"
            alt="QA Path Logo"
            />
        </Box>
        <Typography variant="h5-center" gutterBottom className='title'>
          {title}
        </Typography>
        
        {/* Render subheading if provided */}
        {subheading && (
          <Typography variant="h6" gutterBottom className='sub-title'>
            {subheading}
          </Typography>
        )}


        <form onSubmit={onSubmit} noValidate>
          {children}

          <CustomButton
            type="submit"
            variant="true"
            fullWidth
            // sx={{ mt: 2 , fontSize: '1.1rem' }}
            disabled={loading || submitDisabled}
            className='submit-button'
          >
            {loading ? 'Loading...' : buttonName}
          </CustomButton>

          {error && (
            <Typography color="error" variant="body2" align="center" sx={{ mt: 2 }}>
              {error}
            </Typography>
          )}
        </form>
      </Box>
    </Box>
  );
};

export default FormWrapper;